module.exports = __webpack_public_path__ + "static/media/time.33cd2b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/time.png
// module id = 1303
// module chunks = 110